import { createContext } from 'react';

export const OverScrollHandlerContext = createContext(undefined);

export const UpdateOverScrollHandlerContext = createContext(def => def);
